import { FilterKeys, MessageStatus, useGetMessagesForSchoolCountsQuery } from '@schooly/api';
import { useAuth } from '@schooly/components/authentication';
import {
  buildFiltersSearchParams,
  clearLastAppliedFilter,
  StoredFilterSections,
} from '@schooly/components/filters';
import { useNavigate } from 'react-router-dom';

import useSchoolYears from '../../../../hooks/useSchoolYears';
import { useCallback } from 'react';

export const useMessagesWidgetData = () => {
  const { schoolId = '', relationId = '' } = useAuth();
  const navigate = useNavigate();
  const { defaultValidity } = useSchoolYears();

  const { data, isLoading } = useGetMessagesForSchoolCountsQuery(
    { schoolId, creator: [relationId] },
    { enabled: !!schoolId && !!relationId, refetchOnMount: 'always' },
  );

  const handleNavigate = useCallback(
    (statuses: MessageStatus[]) => {
      if (!defaultValidity) return;

      clearLastAppliedFilter(StoredFilterSections.Messages);

      const filters: Record<string, unknown> = {
        [FilterKeys.Creator]: [relationId],
        [FilterKeys.Date]: [defaultValidity.start, defaultValidity.end],
        [FilterKeys.MessagesStatus]: statuses,
      };

      navigate(`/messages?${buildFiltersSearchParams(filters)}`);
    },
    [defaultValidity, navigate, relationId],
  );

  return {
    counts: data?.counts,
    isLoading,
    handleNavigate,
  };
};
